import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { ValidationError, object, string } from "yup";
import constants from "../../config/constants.json";
import styles from "./volunteer.module.scss";
import {
  CommonButton,
  ContactNumberInput,
  CustomCityStateTextField,
  CustomInputLabel,
  CustomRequiredInputLabel,
} from "../common/StyledComponents/StyledFields";
import apiPath from "../../config/apiPaths.json"
import { CustomTextFeild } from "./below18Component";
import toast, { Toaster } from "react-hot-toast";
import { apiRequest, catchErrorMessageHandler } from "../../infrastructure/backendService";
import ToastSuccess from "../common/toast/toastSuccess";
import { isNil } from "lodash";
import ToastError from "../common/toast/toastError";
import LOCALE from '../../config/en-us.json';
import SuccessPopup from "../devotee/donation/successPopup";
import ErrorPopup from "../common/ErrorPopup";

interface ErrorMessageTypes {
  firstName: string;
  middleName: string;
  lastName: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  email: string;
  phoneNumber: string;
}

var emptyFormFields = {
  firstName: "",
  middleName: "",
  lastName: "",
  address: "",
  city: "",
  state: "",
  zipcode: "",
  email: "",
  phoneNumber: "",
};

const GeneralVolunteer = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] =
    useState<ErrorMessageTypes>({...emptyFormFields});
  const [formData, setFormData] = useState(emptyFormFields);
  const handleFieldChange = (field: string, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = {...emptyFormFields};

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      // saveApiCall();
      setErrorMessage(errors);
      // console.log("Register Successful")
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const zipCodeApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: formData.zipcode,
      },
    })
      .then((res) => {
        setErrorMessage({
          ...errorMessage,
          zipcode: "",
        });
        console.log(res.data.stateName);
        setFormData({
          ...formData,
          state: res.data.stateName,
          city: res.data.city,
        });
      })
      .catch((err) => {
        console.log(err);
        
        setErrorMessage({
          ...errorMessage,
          zipcode: catchErrorMessageHandler(err),
        });
        setFormData({
          ...formData,
          state: "",
          city: "",
        });
      });
  };

  const saveApiCall = () => {
    const reqBody = {
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    };
    apiRequest({
      method: "POST",
      endpoint: "",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        console.log(res);
        const successMessage = LOCALE.GENERAL_VOLUNTEER_REGISTER_SUCCESS;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 10000,
        // });
        toast.custom(<SuccessPopup headerMessage="Registration" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
        setFormData(emptyFormFields);
      })
      .catch((err) => {
        console.log(err);
       

        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const validationSchema = object().shape({
    firstName: string().required("First Name is required"),
    lastName: string().required("Last Name is required"),
    email: string()
      .email("Invalid email address")
      .required("Email is required"),
    // city: string().required("City is required"),
    // state: string().required("State is required"),
    zipcode: string().required("Zipcode is required"),
    phoneNumber: string()
    .required("Phone Number is required")
    .matches(
      /^(\d{3}-){2}\d{4}$/,
      "Phone Number Should be 10 Characters"
    ),
  });


  const validateEmail = () => {
    const { email } = formData;

    if (email.length < 6) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be at least 6 characters long.",
      });
    } else if (email.length >= 64) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be less than 64 characters long.",
      });
    } else if (!email.includes("@")) {
      setErrorMessage({
        ...errorMessage,
        email: "Please Enter Valid Email",
      });
    } else {
      setErrorMessage({ ...errorMessage, email: "" });
    }
  };
  
  return (
    <Box className={styles.generalInfo}>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("First Name", true)}
          <CustomTextFeild
            fullWidth
            required
            value={formData.firstName}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, firstName: "" });
              handleFieldChange("firstName", e.target.value);
            }}
            className={
              errorMessage.firstName ? styles.errorTextField : styles.textField
            }
            placeholder="Enter Firstname"
          />
          {errorMessage.firstName && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.firstName}
            </Typography>
          )}
        </Grid>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Middle Name</CustomInputLabel>
          <CustomTextFeild
            fullWidth
            required
            value={formData.middleName}
            onChange={(e) => {
              //  setErrorMessage({ ...errorMessage, middleName: '' });
              handleFieldChange("middleName", e.target.value);
            }}
            className={
              errorMessage.middleName ? styles.errorTextField : styles.textField
            }
            placeholder="Enter Middlename"
          />
        </Grid>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Last Name", true)}
          <CustomTextFeild
            fullWidth
            required
            value={formData.lastName}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, lastName: "" });
              handleFieldChange("lastName", e.target.value);
            }}
            className={
              errorMessage.lastName ? styles.errorTextField : styles.textField
            }
            placeholder="Enter Lastname"
          />
          {errorMessage.lastName && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.lastName}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Zip Code", true)}
          <CustomTextFeild
            fullWidth
            required
            value={formData.zipcode}
            onChange={(e) => {
              const inputValue = e.target.value;
              // Only allow numbers
              const sanitizedInput = inputValue.replace(/[^0-9]/g, "");
              setErrorMessage({ ...errorMessage, zipcode: "" });
              handleFieldChange("zipcode", sanitizedInput);
            }}
              onBlur={zipCodeApi}
            className={
              errorMessage.zipcode ? styles.errorTextField : styles.textField
            }
            placeholder="Enter Zipcode"
          />
          {errorMessage.zipcode ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.zipcode}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("City", true)}
          <CustomCityStateTextField
            fullWidth
            required
            value={formData.city}
              InputProps={{
                 readOnly: true,
              }}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, city: "" });
              handleFieldChange("city", e.target.value);
            }}
            className={
              errorMessage.city ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.city ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.city}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("State", true)}
          <CustomCityStateTextField
            fullWidth
            required
            value={formData.state}
              InputProps={{
                 readOnly: true,
              }}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, state: "" });
              handleFieldChange("state", e.target.value);
            }}
            className={
              errorMessage.state ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.state ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.state}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Email", true)}
          <CustomTextFeild
            fullWidth
            required
            value={formData.email}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, email: "" });
              handleFieldChange("email", e.target.value);
            }}
            onBlur={validateEmail}
            className={
              errorMessage.email ? styles.errorTextField : styles.textField
            }
            placeholder="Enter Email"
          />
          {errorMessage.email ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.email}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Phone Number", true)}
          <CustomTextFeild
            type="tel"
            fullWidth
            required
            value={formData.phoneNumber}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setErrorMessage({ ...errorMessage, phoneNumber: "" });
              const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
              const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
              handleFieldChange("phoneNumber", slicedNumber);
            }}
            className={
              errorMessage.phoneNumber
                ? styles.errorTextField
                : styles.textField
            }
            placeholder="Enter Phone Number"
          />
          {errorMessage.phoneNumber ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.phoneNumber}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Address", false)}
          <CustomTextFeild
            fullWidth
            required
            value={formData.address}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, address: "" });
              handleFieldChange("address", e.target.value);
            }}
            className={
              errorMessage.address ? styles.errorTextField : styles.textField
            }
            placeholder="Enter Address"
          />
          {errorMessage.address ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.address}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>

      <CommonButton sx={{ marginTop: "16px" }} onClick={handleSave}>
        Submit
      </CommonButton>
    </Box>
  );
};

export default GeneralVolunteer;
